import { useMemo } from "react";
import { WizardStep } from "../types/WizardStep";

export function useWizardRootStep<TState>(steps: WizardStep<TState>[]) {
  return useMemo<WizardStep<TState>>(
    () => ({ steps, title: "", pathSegment: "" }),
    [steps],
  );
}
